import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter,Route,Routes } from "react-router-dom";
import App from './App';

function getQueryVariable(variable)
{
        var query = window.location.search.substring(1);
        console.log(query)//"app=article&act=news_content&aid=160990"
        var vars = query.split("&");
        console.log(vars) //[ 'app=article', 'act=news_content', 'aid=160990' ]
        for (var i=0;i<vars.length;i++) {
                    var pair = vars[i].split("=");
                    console.log(pair)//[ 'app', 'article' ][ 'act', 'news_content' ][ 'aid', '160990' ] 
        if(pair[0] == variable){return pair[1];}
         }
         return(false);
}

ReactDOM.render(
  
   
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="BMI" element={ <App contentType='BMI' />} />
      <Route path="stock" element={ <App contentType='stock' />} />
      <Route path="length" element={ <App contentType='length' />} />
    </Routes>
  </BrowserRouter>
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
